export default __webpack_public_path__ + "static/media/partner.7cac9069.webp";